import "./Spinner.css";

// export default function Spinner({ height }) {
//   return (
//     <div data-testid="spinner-wrapper" className="spinner-wrapper" style={{ height: `${height}` }}>
//       <img width="40px" src="/img/loader.gif" alt="" />
//     </div>
//   );
// }

import "./Spinner.css";

interface SpinnerProps {
  height?: string;
  children?: React.ReactNode;
  onRight?: boolean;
}

export default function Spinner({ height = "40px", children, onRight = false }: SpinnerProps) {
  const style = onRight
    ? {
        height,
        display: "flex",
        alignItems: "center",
        gap: "8px",
      }
    : { height: height };
  return (
    <div data-testid="spinner-wrapper" className="spinner-wrapper" style={style}>
      <img width="40px" src="/img/loader.gif" alt="Loading..." />
      {children && <span>{children}</span>}
    </div>
  );
}
